/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Route, withRouter} from 'react-router-dom'
import {Routes} from './utils/Routes'

import 'react-toastify/dist/ReactToastify.css';
import '@scuf/common/honeywell-dark/theme.css'
import '@scuf/datatable/honeywell/theme.css'
import './styling/index.css'
import * as SecurityActions from './security/SecurityActions'
import * as VersionActions from './version/VersionActions'
import {cleanJwsToken, isAuthenticated, isLoginPage} from './api/HttpUtils'
import MainPage from './layout/MainPage'
import Login from './login/Login'
import Loader from './common/Loader'
import LocaleHelper from './common/LocaleHelper'
import Auth from './honeywellSSO/Auth'
import Airtime from './airtime/AirtimeMainPage'

class App extends Component {

    /**
     * Method checks authentication status. If user is authenticated it fetches user profile.
     * If unable to fetch user profile redirect to Login page. Also when authenticated and
     * accessing Login page, redirect to the authenticated part of app automatically
     */
    componentDidMount() {
        const {history, Security, Version} = this.props
        Version.fetchVersionInfo()
        if (isAuthenticated()) {
            Security.loadUserProfile()
                .then(profile => {
                    if (!profile) {
                        cleanJwsToken()
                        Security.signOut()
                        history.push(Routes.LOGIN)
                    } else {
                        const authenticated = !!(profile && profile.userName)
                        if (isLoginPage() && authenticated) {
                            history.push(Routes.HOME)
                        }
                    }
                })
        }
    }

    title() {
        if (this.props.build.version && this.props.build.version.length > 0) {
            document.title = this.props.build.name + " - " + this.props.build.version
        }
    }

    render() {
        const {userProfile, loading} = this.props.security
        const authenticated = userProfile && userProfile.userName ? true : false

        let component;
        if ((authenticated && loading) || (!authenticated && isAuthenticated())) {
            component = <Loader loading={loading}/>
        } else if (authenticated) {
            component = <MainPage authenticated={authenticated}/>
        } else if (window.location.href.includes("/auth")) {
            component = <Route path={"/auth"} component={Auth} />
        } else if (window.location.href.includes("/airtime/session")) {
            component = <Route path={"/airtime/session"} component={Airtime}/>
        } else {
            component = <Route path={Routes.LOGIN} component={Login} />
        }

        return (
            <React.Fragment>
                <LocaleHelper/>
                {this.title()}
                {component}
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({security, version}) => {
    return {
        security: security,
        build: version.build,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        Security: bindActionCreators(SecurityActions, dispatch),
        Version: bindActionCreators(VersionActions, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
